module.exports = __webpack_public_path__ + "img/wz-7-5-1.6e709abf.jpg";